import styles from "./Avatar.module.scss";

interface AvatarProps {
  text: string;
}

function getInitials(name: string): string {
  const s = name.trim();
  const res = s
    .split(/\s+/)
    .slice(0, 2)
    .map(v => v[0])
    .join("");

  return (res.length < 2 ? name.slice(0, 2) : res).toUpperCase();
}

const Avatar = (props: AvatarProps) => {
  return (
    <div className={styles.avatar}>
      {getInitials(props.text)}
    </div>
  );
};

export default Avatar;
